import { UserManager } from "oidc-client";

class OidcAuthService {
	constructor() {
		const settings = {
			authority: process.env.REACT_APP_AUTHORITY, // The OIDC provider URL
			client_id: "offcampus-accomodation-test-client", // Your client ID
			redirect_uri: process.env.REACT_APP_REDIRECT_URL, // The redirect URL after authentication
			post_logout_redirect_uri: `https://localhost:5000/`, // The redirect URL after logout
			response_type: "code",
			scope: "openid profile",
			client_secret: process.env.REACT_APP_CLIENT_SECRET,

			// authority: process.env.REACT_APP_AUTHORITY,
			// clientId: "offcampus-accomodation-test-client",
			// clientSecret: process.env.REACT_APP_CLIENT_SECRET,
			// scope: process.env.REACT_APP_SCOPE,
			// redirectUri: process.env.REACT_APP_REDIRECT_URL,
			// responseType: process.env.REACT_APP_RESPONSE_TYPE,
		};

		this.userManager = new UserManager(settings);
	}

	login() {
		return this.userManager.signinRedirect();
	}

	logout() {
		return this.userManager.signoutRedirect();
	}

	async getUser() {
		const user = await this.userManager.getUser();
		return user;
	}

	async completeLogin() {
		const user = await this.userManager.signinRedirectCallback();
		localStorage.setItem("stUser", user?.profile);
		return user;
	}

	async completeLogout() {
		await this.userManager.signoutRedirectCallback();
	}
}

const oidcAuthService = new OidcAuthService();
export default oidcAuthService;
